// src/components/ProfileGateModal.js
import React, { useState } from "react";
import { supabase } from "../lib/supabase";

export function ProfileGateModal({ session, onComplete, onClose, saveUsers, users }) {
  const [phone, setPhone] = useState(session?.user?.phone || "");
  const [name,  setName]  = useState(session?.user?.name  || "");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const needsPhone = !(session?.user?.phone || "").replace(/\D/g,"").length >= 7;
  const needsName  = !(session?.user?.name  || "").trim();

  const handleSave = async () => {
    const phoneDigits = phone.replace(/\D/g,"");
    if (phoneDigits.length < 7) { setErr("Enter a valid WhatsApp number (at least 7 digits)."); return; }
    if (needsName && !name.trim()) { setErr("Please enter your name."); return; }
    setSaving(true); setErr("");
    try {
      const updates = { phone };
      if (needsName) updates.name = name.trim();
      const { error } = await supabase.from("users").update(updates).eq("id", session.user.id);
      if (error) throw error;
      // Update local users array and session via parent
      const updatedUser = { ...session.user, ...updates };
      if (saveUsers && users) saveUsers(users.map(u => u.id === session.user.id ? updatedUser : u));
      onComplete(updatedUser);
    } catch(e) { setErr("Couldn't save — please try again."); }
    finally { setSaving(false); }
  };

  return (
    <div className="overlay" onClick={e=>{if(e.target===e.currentTarget)onClose();}}>
      <div className="modal fade-in" style={{maxWidth:380}}>
        <button onClick={onClose} style={{position:"absolute",top:16,right:18,background:"none",fontSize:20,color:"var(--ink3)",lineHeight:1}}>×</button>
        <div style={{fontSize:32,marginBottom:12,lineHeight:1}}>◎</div>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:10}}>One quick thing</div>
        <p style={{fontSize:13,color:"var(--ink2)",lineHeight:1.7,marginBottom:24}}>
          We need your WhatsApp number to connect you with sellers and send updates when a watch is found.
        </p>
        {needsName && (
          <div style={{marginBottom:14}}>
            <label className="fl">Your name *</label>
            <input value={name} onChange={e=>{setName(e.target.value);setErr("");}} placeholder="Arjun Sharma" type="text" autoComplete="name" autoCapitalize="words"/>
          </div>
        )}
        <div style={{marginBottom:20}}>
          <label className="fl">WhatsApp number *</label>
          <input value={phone} onChange={e=>{setPhone(e.target.value);setErr("");}} placeholder="+91 98xxx xxxxx" type="tel" inputMode="tel" autoComplete="tel" autoFocus/>
          <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",marginTop:5}}>Used only for order updates. Never shared with other users.</div>
        </div>
        {err && <div style={{color:"var(--red)",fontSize:12,marginBottom:14,textAlign:"center"}}>{err}</div>}
        <button className="btn-ink" style={{width:"100%",padding:13,fontSize:14,justifyContent:"center",opacity:saving?0.6:1}} onClick={handleSave} disabled={saving}>
          {saving ? "Saving…" : "Save & Continue →"}
        </button>
      </div>
    </div>
  );
}
